import React from 'react'
import Grid from 'react-bootstrap/lib/Grid'
import Row from 'react-bootstrap/lib/Row'
import Col from 'react-bootstrap/lib/Col'
// // import LumensRates from '../shared/LumensRates'

class Footer extends React.PureComponent {
  render() {
    return (
      <Grid id="footer">
        <div className="footer-wrapper">
          <Row>
            <Col>
                <a target="_blank" rel="noopener noreferrer" href="https://bantufoundation.org">
                  <p className="company-text"> Bantu Blockchain Foundation</p>
                </a>
            </Col>
          </Row>
          <Row>
          <Col>
            <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/bantublockchain">
              <i className="fa fa-twitter social-icons"></i>
            </a>
            <a
              target="_blank" rel="noopener noreferrer"
              href="https://www.facebook.com/bantublockchain"
            >
              <i className="fa fa-facebook social-icons"></i>
            </a>
            <a
              target="_blank" rel="noopener noreferrer"
              href="https://www.linkedin.com/company/bantublockchain"
            >
              <i className="fa fa-linkedin social-icons"></i>
            </a>
            <a
              target="_blank" rel="noopener noreferrer"
              href="https://www.instagram.com/bantublockchain"
            >
              <i className="fa fa-instagram social-icons"></i>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://github.com/bantublockchain">
              <i className="fa fa-github social-icons"></i>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://medium.com/@bantublockchain">
              <i className="fa fa-medium social-icons"></i>
            </a>
            <a
              target="_blank" rel="noopener noreferrer"
              href="https://www.reddit.com/r/bantublockchain"
            >
              <i className="fa fa-reddit social-icons"></i>
            </a>
            <a
              target="_blank" rel="noopener noreferrer"
              href="https://www.youtube.com/channel/UCXP0KYKl1jLG-0QbeMH86IA"
            >
              <i className="fa fa-youtube social-icons"></i>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://t.me/bantublockchain">
              <i className="fa fa-telegram social-icons"></i>
            </a>
            </Col>
          </Row>
        </div>
      </Grid>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/layout/Footer.js